import { fetchVideochats, removeVideochat } from "../actions";
import { updateConsultStatus } from "./chatProvider";
//var database = firebase.firestore();
var database = {};

export const createVideochat = async (
  customer,
  professional,
  available_credits,
  price_per_hour,
  customer_name,
  professional_name
) => {
  const max_available_minutes = Math.ceil(
    (available_credits * 60) / price_per_hour
  );

  return database
    .collection("video_chats")
    .doc(`${customer}+${professional}`)
    .get()
    .then(doc => {
      if (doc.exists) {
        //console.log('Já existe um videochat');
        //atualizar status do chat para requested novamente...
        return database
          .collection("video_chats")
          .doc(`${customer}+${professional}`)
          .update({
            status: "requested",
            price_per_hour,
            max_available_minutes,
            available_credits,
            inactive_time: 0,
            credits_expired: false
          });
        //return {exists: true, message: 'Já existe um chat'}
      }
      //criar videochat
      let members = {};
      members[customer] = true;
      members[professional] = true;
      return database
        .collection("video_chats")
        .doc(`${customer}+${professional}`)
        .set({
          members: members,
          status: "requested",
          professional,
          customer,
          price_per_hour,
          max_available_minutes,
          available_credits,
          inactive_time: 0,
          customer_name,
          professional_name
        });
    })
    .then(result => {
      if (result) {
        return result;
      }
      return { created: true };
    })
    .catch(error => {
      console.log(error);
      return { error: true };
    });
};

/* export const getVideochats = userId => dispatch => {
  const unsubscribe = database
    .collection("video_chats")
    .where("professional", "==", userId)
    .where("status", "==", "requested")
    .onSnapshot(querySnapshot => {
      //console.log(querySnapshot);
      let list = [];
      querySnapshot.docChanges().forEach(change => {
        //if(change.type !== 'added') return;

        if (change.type === "modified") {
          console.log("modified");

          //dispatch(updateChatLastMessage(change.doc.id,change.doc.data().last_message))
          //dispatch(updateChatData(change.doc.id,change.doc.data()));
          return;
        }

        if (change.type === "removed") {
          console.log("removed");
          dispatch(removeVideochat({ ref: change.doc.id }));
          return;
        }

        if (change.type === "added") {
          const data = change.doc.data();

          list.push({
            ref: change.doc.id,
            data
            //contact: {id: contactId},
          });
        }
      });
      dispatch(fetchVideochats(list));
    });

  return unsubscribe;
}; */

export const activateVideochat = async (id, token) => {
  console.log("ACTIVATE VIDEOCHAT TO BE TESTED");
  updateConsultStatus(id, "active", token);
  /* return database
    .collection("video_chats")
    .doc(id)
    .update({
      status: "active",
      begin_time: new Date()
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    }); */
};

export const finalizeVideochat = async (id, token) => {
  updateConsultStatus(id, "finished", token);
  /* return database
    .collection("video_chats")
    .doc(id)
    .update({
      status: "finished",
      end_time: new Date(),
      credits_expired
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    }); */
};

export const cancelVideochat = async (id, token) => {
  console.log("CANCEL VIDEOCHAT TO BE TESTED");
  updateConsultStatus(id, "canceled", token);
  /* return database
    .collection("video_chats")
    .doc(id)
    .update({
      status: "canceled"
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    }); */
};

/* export const refuseVideochat = async id => {
  return database
    .collection("video_chats")
    .doc(id)
    .update({
      status: "canceled"
    })
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      console.log(error);
    });
}; */
